'use client'

import { clsx } from 'clsx'
import { type FC } from 'react'

import { useProductAddToCartQuantitySelectionDiscountBadgeData } from './useProductAddToCartQuantitySelectionDiscountBadgeData'

export const ProductVolumePricingCompactDiscountBadge: FC<{
  className?: string
  selectedValue: number
}> = ({ className, selectedValue }) => {
  const { discount } =
    useProductAddToCartQuantitySelectionDiscountBadgeData(selectedValue)

  if (discount && discount > 0) {
    return (
      <div
        // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
        className={clsx(
          'inline-block items-center justify-center rounded-full p-[5px] text-xs font-medium text-dark-primary-max',
          className,
          'bg-light-tertiary',
        )}
      >
        {`-${discount}%`}
      </div>
    )
  }

  return null
}
